"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FromLong_1 = require("./FromLong");
function mask(subnet) {
    var split = subnet.split('/');
    var longMask = Math.pow(2, 32) - Math.pow(2, 32 - parseInt(split[1], 10));
    return FromLong_1.fromLong(longMask);
}
exports.mask = mask;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFzay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk1hc2sudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx1Q0FBcUM7QUFFckMsY0FBc0IsTUFBYztJQUNsQyxJQUFJLEtBQUssR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQzdCLElBQUksUUFBUSxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxFQUFFLEVBQUUsR0FBRyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUE7SUFDekUsTUFBTSxDQUFDLG1CQUFRLENBQUMsUUFBUSxDQUFDLENBQUE7QUFDM0IsQ0FBQztBQUpELG9CQUlDIn0=


//////////////////
// WEBPACK FOOTER
// ./src/Mask.ts
// module id = 4
// module chunks = 0